// Shortcut and workaround for https://github.com/angular/material/issues/6810
import errorsTemplate from './errors.html';

export default /* @ngInject */ function ($templateCache, $compile) {

    function compile(element) {
        // Using a trick to do a ng-transclude without keeping the
        // [ng-transclude] element, which does not play nice with
        // angular-material.
        let transcluded = element.children().detach();
        return {
            post: function postLink(scope, _, attrs, ngForm) {

                let errorMessages = '';
                angular.forEach(transcluded, (elem) => {
                    errorMessages += elem.outerHTML;
                });

                let errors = $templateCache.get(errorsTemplate).replace(
                    '<ng-transclude></ng-transclude>',
                    errorMessages
                );
                scope.form = ngForm;
                scope.model = ngForm[attrs.for];
                element.replaceWith($compile(errors)(scope));
            }
        };
    }

    return {
        scope: true,
        compile: compile,
        require: '^form'
    };
}



// WEBPACK FOOTER //
// ./forms/directives/errors.js